import { useLocation, useNavigate } from 'react-router-dom'
import { 
  LayoutDashboard, 
  TrendingUp, 
  Settings,
  Calendar,
  UserPlus,
  Network,
  CreditCard,
  Bell
} from 'lucide-react'
import { NavItem } from './NavItem'
import { ThemeToggle } from '@/components/theme/ThemeToggle'
import { useAuthStore } from '@/stores/auth.store'
import { useTranslation } from 'react-i18next'

export const Sidebar = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const isAdmin = useAuthStore(state => state.isAdmin)
  const isRestrictedUser = useAuthStore(state => state.user?.emergency_mode ?? false)
  const hasIxenSystemAccess = useAuthStore(state => state.hasIxenSystemAccess)

  const tradingChildren = isRestrictedUser
    ? [
        { name: 'iXen Console', href: '/trading/console' }
      ]
    : isAdmin
    ? [
        { name: 'iXen Console', href: '/trading/console' },
        { name: 'iXen System', href: '/trading/system' },
        { name: '↓ Download EA', href: '/trading/downloads' }
      ]
    : hasIxenSystemAccess
    ? [
        { name: 'iXen Console', href: '/trading/console' },
        { name: 'iXen System', href: '/trading/system' },
        { name: '↓ Download EA', href: '/trading/downloads' }
      ]
    : [
        { name: 'iXen Console', href: '/trading/console' }
      ]

  const navigation = [
    {
      name: t('nav.dashboard'),
      href: '/dashboard',
      icon: LayoutDashboard,
      current: location.pathname === '/dashboard'
    },
    {
      name: t('nav.trading'),
      icon: TrendingUp,
      current: location.pathname.startsWith('/trading'),
      children: tradingChildren
    },
    {
      name: 'Referral',
      href: '/referral',
      icon: UserPlus,
      current: location.pathname === '/referral'
    },
    {
      name: 'Abbonamento',
      href: '/pricing',
      icon: CreditCard,
      current: location.pathname === '/pricing'
    },
    {
      name: 'Notifiche',
      href: '/notifications',
      icon: Bell,
      current: location.pathname === '/notifications'
    }
  ]

  navigation.push({
    name: 'iXen Network',
    href: '/ixen',
    icon: Network,
    current: location.pathname === '/ixen'
  })

  // Add Admin menu only if user is admin
  if (isAdmin) {
    navigation.push(
      {
        name: t('nav.admin'),
        icon: Settings,
        current: location.pathname.startsWith('/admin'),
        children: [
          { name: t('nav.userAccounts'), href: '/admin/users' },
          { name: 'Abbonamenti', href: '/admin/subscriptions' },
          { name: t('nav.propFirms'), href: '/admin/propfirms' },
          { name: '💰 Profitti Verificati', href: '/admin/profits' },
          { name: t('nav.emergency'), href: '/admin/emergency' },
          { name: t('nav.analytics'), href: '/admin/analytics' },
          { name: '🌐 iXen Network', href: '/admin/ixen' },
          { name: '📡 Monitor Segnali', href: '/admin/monitor' },
          { name: '🔬 Backtest Engine', href: '/admin/backtest' },
          { name: '📊 Cicli Prop', href: '/admin/cycles' },
          { name: '🛡️ Zanshin', href: '/admin/zanshin' },
          { name: '🎨 Demo stati', href: '/admin/zanshin-demo' }
        ]
      },
      {
        name: t('nav.calendar'),
        icon: Calendar,
        current: location.pathname.startsWith('/calendar'),
        children: [
          { name: t('nav.newsEvents'), href: '/calendar/events' },
          { name: t('nav.import'), href: '/calendar/import' },
          { name: t('nav.analytics'), href: '/calendar/analytics' }
        ]
      }
    )
  }

  return (
    <div className="w-64 bg-card border-r flex flex-col">
      <div className="flex items-center justify-center h-16 border-b px-6">
        <TrendingUp className="h-8 w-8 text-primary" />
        <span className="ml-2 text-xl font-bold">TradeBridgePro</span>
      </div>
      
      <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
        {navigation.map((item) => (
          <NavItem
            key={item.name}
            item={item}
            currentPath={location.pathname}
            onNavigate={navigate}
          />
        ))}
      </nav>
      
      <div className="border-t p-4 space-y-3">
        <ThemeToggle />
        <div className="text-xs text-muted-foreground text-center">
          v2.0.0 - Advanced News Engine
        </div>
      </div>
    </div>
  )
}
